// Bearer-token store for the embedded (cross-origin iframe) flow.
//
// In a normal browser session auth rides on the HttpOnly session cookie and this
// store stays empty. Inside a cross-origin iframe that cookie is dropped
// (SameSite=Lax + third-party cookie blocking), so we exchange the single-use
// magic link for a JWT once and replay it as `Authorization: Bearer` on every
// request. sessionStorage keeps the token alive across iframe reloads within the
// frame session (the magic link can't be replayed) and is cleared when the frame
// closes. It is partitioned per-origin in third-party contexts.

const STORAGE_KEY = 'received_access_token';

// Mirror of the stored value so the request interceptor avoids a sessionStorage
// read on every call, and so auth still works if storage access throws.
let cachedToken: string | null | undefined;

export const setAuthToken = (token: string) => {
	cachedToken = token;
	try {
		sessionStorage.setItem(STORAGE_KEY, token);
	} catch {
		// sessionStorage can be unavailable/blocked; in-memory cache is enough for this session.
	}
};

export const getAuthToken = (): string | null => {
	if (cachedToken === undefined) {
		try {
			cachedToken = sessionStorage.getItem(STORAGE_KEY);
		} catch {
			cachedToken = null;
		}
	}
	return cachedToken;
};

export const clearAuthToken = () => {
	cachedToken = null;
	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch {
		// nothing to clean up if storage is unavailable.
	}
};
